// removed by extract-text-webpack-plugin
module.exports = {"container":"NavBar-container-c40643ae","innerContainer":"NavBar-innerContainer-84f3f53d","price":"NavBar-price-8490d40d","callback":"NavBar-callback-05619aed","phoneContainer":"NavBar-phoneContainer-ae7f235f","icon":"NavBar-icon-118fca89","top":"NavBar-top-cd4f47bb"};


//////////////////
// WEBPACK FOOTER
// ./src/Detail/NavBar/NavBar.scss
// module id = 926
// module chunks = 0